import React from 'react'
import About from '../9'
import { RealEstateDataPageComponentData } from 'types'

const AboutUs18 = ({
  title,
  global_data,
  paragraphs,
  subtitle,
  subtitleElement,
  height
}: RealEstateDataPageComponentData) => {
  return (
    <About
      title={title}
      global_data={global_data}
      paragraphs={paragraphs}
      subtitle={subtitle}
      subtitleElement={subtitleElement}
      height={height}
      myConfig={true}
    />
  )
}

export default AboutUs18
